var StopLocation = require('js/lib/stopLocation');
var moveStopLocationTemplate = require('html/templates/moveStopLocation')();
var moveStopLocationsTemplate = require('html/templates/moveStopLocations')();
var optimizeRouteWithOptionsTemplate = require('html/templates/optimizeRouteWithOptions')();
var t = require('js/lib/translate').t;
var moment = require('js/lib/moment');

planRoutesCtrl.$inject = ['$scope', '$rootScope', '$controller', '$route', '$location', 'modal', 'load', 'editRoute'];

function planRoutesCtrl($scope, $rootScope, $controller, $route, $location, modal, load, editRoute) {

  $controller('planCtrl', { $scope: $scope });

  $scope.ctrlKey = window.navigator.platform.indexOf('Mac') === -1 ? 'ctrl' : 'cmd';

  $scope.reserveRoutes = $route.current.reserveRoutes;

  $scope.routeFilter = {
    status: $scope.reserveRoutes ? 'reserved' : undefined
  };

  $scope.openEditRoute = editRoute.openEditRoute.bind(this, $scope);
  $scope.saveRoute = editRoute.saveRoute.bind(this, $scope);
  $scope.deleteEmptyRoute = editRoute.deleteEmptyRoute.bind(this, $scope);

  $scope.expandedRoutes = {};
  $scope.selectedStops = {};

  $scope.toggleExpandRoute = function(event, route) {
    event.preventDefault();
    $scope.expandedRoutes[route.id] = ! $scope.expandedRoutes[route.id];
  };

  $scope.showFailedInfoRoutes = {};

  $scope.toggleFailedInfo = function(route) {
    $scope.showFailedInfoRoutes[route.id] = ! $scope.showFailedInfoRoutes[route.id];
  };

  $scope.openMoveStopLocation = function(stopLocation) {
    $scope.prepareMove(stopLocation);
    modal.open({
      scope: $scope,
      klass: 'move-stop-location',
      title: t('moveModalHeader'),
      body: moveStopLocationTemplate
    });
  };

  $scope.prepareMove = function(stopLocation) {

    var oldIndex = function(stop) {
      return stop.routeSequence && stop.routeSequence - 1;
    };

    var stops;

    if (stopLocation instanceof Array) {
      stops = stopLocation;
      stopLocation = stopLocation[0];
    }

    $scope.move && $scope.move.close && $scope.move.close();

    $scope.move = {
      stop: stopLocation,
      route: stopLocation.route,
      oldIndex: oldIndex(stopLocation),
      newIndex: stopLocation.route && ('' + oldIndex(stopLocation)),
      routeSelected: function(route) {
        $scope.move.newIndex = route && '' + route.stopLocations.length;
      },
      routeFilter: {
        type: (stopLocation.route && stopLocation.route.reserved ? 1 : 0)
      }
    };

    if (stops && stops.length > 1) {
      var index = 0;
      $scope.move.next = function() {
        if (! stops[++index]) index = 0;
        $scope.move.stop = stops[index];
        $scope.move.oldIndex = oldIndex(stops[index]);
      };
    }
  };

  $scope.moveStopLocation = function(stopLocation, oldIndex, newIndex, newRouteId) {

    var updateSequence = function(route) {
      route.stopLocations.forEach(function(stop, index) {
        stop.routeSequence = index + 1;
      });
    };

    var route = stopLocation.route;
    var oldRouteId = route && route.id;
    var updatedRoutes = route ? [route] : [];

    ($scope.move && $scope.move.close) ? $scope.move.close() : $scope.closeModal();

    if (route && route.id === newRouteId) newRouteId = null;
    if (oldIndex === newIndex && ! newRouteId) return;

    if (newRouteId) {
      var newRoute = $scope.routePlan.findRoute(newRouteId);

      stopLocation.route = newRoute;
      stopLocation.customers.forEach(function(customer) {
        customer.routeId = newRouteId;
      });

      updatedRoutes.push(newRoute);
      newRoute.stopLocations.splice(newIndex, 0, stopLocation);
      updateSequence(newRoute);

      if (route) {
        route.stopLocations.splice(oldIndex, 1);
        updateSequence(route);
      }

      if ($scope.selectedStops[oldRouteId]) {
        delete $scope.selectedStops[oldRouteId][stopLocation.id];
      }
    } else if (route) {
      route.stopLocations.splice(newIndex, 0, route.stopLocations.splice(oldIndex, 1)[0]);
      updateSequence(route);
    }

    load.saveRouteSequence($scope.routePlan.id, updatedRoutes);
  };

  $scope.prepareMultiMove = function(stopLocations, oldRoute) {
    $scope.multiMove = {
      stops: stopLocations,
      route: null,
      oldRoute: oldRoute,
      customerCount: function() {
        return stopLocations.reduce(function(count, stop) {
          return count + stop.customerNotCancelledCount();
        }, 0);
      },
      routeFilter: {
        type: (oldRoute && oldRoute.reserved ? 1 : 0)
      }
    };
  };

  $scope.moveStopLocations = function(stopLocations, newRouteId) {

    var updateSequence = function(route) {
      route.stopLocations.forEach(function(stop, index) {
        stop.routeSequence = index + 1;
      });
    };

    $scope.multiMove.close ? $scope.multiMove.close() : $scope.closeModal();

    if (newRouteId === undefined) return;

    var newRoute = $scope.routePlan.findRoute(newRouteId);
    var involvedRouteIds = {};
    var updatedRoutes = [];

    stopLocations.forEach(function(stopLocation) {
      var oldRoute = stopLocation.route;

      if (oldRoute && oldRoute.id !== newRouteId) { // Only do work if needed
        var oldIndex = stopLocation.route.stopLocations
          .map(function(stop) { return stop.id; })
          .indexOf(stopLocation.id);

        involvedRouteIds[oldRoute.id] = oldRoute.id;

        stopLocation.route = newRoute;
        stopLocation.customers.forEach(function(customer) {
          customer.routeId = newRouteId;
        });

        oldRoute.stopLocations.splice(oldIndex, 1); // Remove from old route
        newRoute.stopLocations.push(stopLocation);  // Add to (end of) new route
      }
    });

    if (Object.keys(involvedRouteIds).length > 0) {
      involvedRouteIds[newRouteId] = newRouteId; // The new route must also be included

      Object.keys(involvedRouteIds).forEach(function(rId) {
        var r = $scope.routePlan.findRoute(parseInt(rId, 10));

        updateSequence(r);
        updatedRoutes.push(r);

        delete $scope.selectedStops[rId];
      });

      load.saveRouteSequence($scope.routePlan.id, updatedRoutes);
    }
  };

  $scope.openMoveStopLocations = function(route) {
    var stops = $scope.values($scope.selectedStops[route.id] || {});

    var sortByRouteSequence = function(a, b) {
      return a.routeSequence - b.routeSequence;
    };

    if (stops.length === 1) {
      $scope.openMoveStopLocation(stops[0]);
    } else if (stops.length) {
      stops.sort(sortByRouteSequence);
      $scope.prepareMultiMove(stops, route);
      modal.open({
        scope: $scope,
        klass: 'move-stop-location',
        title: t('moveModalHeader'),
        body: moveStopLocationsTemplate
      });
    }
  };

  $scope.selectStop = function(event, stop) {
    $scope.selectedStops[stop.route.id] = $scope.selectedStops[stop.route.id] || {};
    if (event.target.checked) {
      $scope.selectedStops[stop.route.id][stop.id] = stop;
    } else {
      delete $scope.selectedStops[stop.route.id][stop.id];
    }
  };

  $scope.selectAllStops = function(event, route) {
    route.stopLocations.forEach(function(stop) {
      if (stop.anyUnAccountedDeliveries()) {
        $scope.selectStop(event, stop);
      }
    });
  };

  $scope.allStopsSelected = function(route) {
    return $scope.countStopsSelected(route) === route.stopLocations.length;
  };

  $scope.countStopsSelected = function(route) {
    return Object.keys($scope.selectedStops[route.id] || {}).length;
  };

  $scope.toStopLocation = function(customer) {
    return new StopLocation(customer);
  };

  $scope.canEditRouteInfo = function(routePlan) {
    return $rootScope.auth.roles.fleetManager ||
      ($rootScope.auth.roles.clientPlus && $scope.reserveRoutes && routePlan.hasAccessToAllCustomerSystems($rootScope.auth.customerSystemIds));
  };

  $scope.canMoveStops = function(routePlan) {
    return $rootScope.auth.roles.planner ||
      ($rootScope.auth.roles.fleetManager && $scope.reserveRoutes) ||
      ($rootScope.auth.roles.clientPlus && $scope.reserveRoutes && routePlan.hasAccessToAllCustomerSystems($rootScope.auth.customerSystemIds));
  };

  $scope.showAskForDriverInput = function(routePlan) {
    var hasSomeCustomerSystemsThatWantsDriverInput = $scope.settings.customerSystemSettings && $scope.settings.customerSystemSettings.some(function(css) {
      return routePlan.customerSystems.indexOf(css.customerSystemId)>=0 && css.askForDriverInput;
    });

    return hasSomeCustomerSystemsThatWantsDriverInput && ! routePlan.readyForDriverInput;
  };

  $scope.askForDriverInput = function(routePlan) {
    modal.open({
      scope: $scope,
      title: t('planRoutesAskForDriverInputBtn'),
      body: t('planRoutesAskForDriverInputBtnConfirm', routePlan.name, moment(routePlan.date).format('L'), moment(routePlan.date).format('dddd'), moment(routePlan.date).fromNow()),
      onConfirm: function() {
        load.enableDriverInputForRoutePlan(routePlan.id).then(function() {
          $location.path($scope.router.link('plans'));
        });
      }
    });
  };

  $scope.publish = function(routePlan) {
    modal.open({
      scope: $scope,
      title: t('planRoutesPublishBtn'),
      body: t('planRoutesPublishBtnConfirm', routePlan.name, moment(routePlan.date).format('L'), moment(routePlan.date).format('dddd'), moment(routePlan.date).fromNow()),
      onConfirm: function() {
        load.publishRoutePlan(routePlan.id).then(function() {
          $location.path($scope.router.link('plans'));
        });
      }
    });
  };

  $scope.addRoute = function(event, routePlan) {
    $scope.openEditRoute(event, { permitDriverComingSMS: true });
  };

  $scope.addReserveRoute = function(event, routePlan) {
    $scope.openEditRoute(event, { permitDriverComingSMS: true, type: 1 });
  };

  $scope.deleteRoutes = function(routePlan) {
    modal.open({
      scope: $scope,
      title: t('planRoutesDeleteAllRoutes'),
      body: t('planRoutesDeleteAllRoutesConfirm'),
      onConfirm: function() {
        load.deleteRoutes(routePlan.id);
        $location.path($scope.router.link('plan/customers', routePlan.id).replace('#', ''));
      }
    });
  };

  $scope.optimizeRoute = function(route) {
    route.optimizationStatus = 1; // Default set to waiting
    load.optimizeRoute(route.id);
  };

  $scope.openOptimizeRouteWithOptions = function(route) {
    var selectedFirstStopLocation = $scope.routePlan.findStopLocation(route.id, route.forcedFirstStopLocationId);
    var selectedLastStopLocation = $scope.routePlan.findStopLocation(route.id, route.forcedLastStopLocationId);
    $scope.optimizeRouteOptions = {
      route: route,
      selectedFirstStopLocation: selectedFirstStopLocation,
      selectedLastStopLocation: selectedLastStopLocation
    };
    modal.open({
      scope: $scope,
      klass: 'optimize-route-with-options',
      title: t('optimizeRouteModalHeader', route.name),
      body: optimizeRouteWithOptionsTemplate
    });
  };

  $scope.optimizeRouteWithOptions = function(optimizeRouteOptions) {
    var route = optimizeRouteOptions.route;
    route.optimizationStatus = 1; // Default set to waiting
    var firstStopId = optimizeRouteOptions.selectedFirstStopLocation ? optimizeRouteOptions.selectedFirstStopLocation.id : null;
    var lastStopId = optimizeRouteOptions.selectedLastStopLocation ? optimizeRouteOptions.selectedLastStopLocation.id : null;
    load.optimizeRouteWithOptions(route.id, firstStopId, lastStopId).then(function() {
      $scope.closeModal();
    });
  };

  $scope.optimizeAllNeededRoutes = function(routePlan) {
    routePlan.routesThatNeedOptimization().forEach(function(route) {
      return route.optimizationStatus = 1; // Default set to waiting
    });
    load.optimizeAllNeededRoutes(routePlan.id);
  };

  $scope.clearTimeWindowsAndOptimizeRoute = function(route) {
    route.optimizationStatus = 1; // Default set to waiting
    load.clearTimeWindowsAndOptimizeRoute(route.id);
  };

}

module.exports = planRoutesCtrl;



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/controllers/planRoutesCtrl.js
 ** module id = 132
 ** module chunks = 1
 **/